import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { isGroupedOptin } from '../types.js';

function ungroupOptIns(optIns) {
    return optIns.flatMap((curr)=>isGroupedOptin(curr) ? curr.groupedOptIns : curr
    );
}
function omitGroupedOptIns(optIns) {
    return optIns.filter((optIn)=>!isGroupedOptin(optIn)
    );
}
const formatOptIns = (availableOptIns1, selectedOptIns1, getLabel)=>{
    const formatOptInsWithSelection = (availableOptIns, selectedOptIns)=>{
        const ungroupedAvailableOptins = ungroupOptIns(availableOptIns);
        const ungroupedSelectedOptins = ungroupOptIns(selectedOptIns);
        return ungroupedAvailableOptins.map((optIn)=>swcHelpers.objectSpread({}, optIn, {
                isSelected: ungroupedSelectedOptins.some((s)=>optIn.value === s.value
                )
            })
        );
    };
    const formatOptIn = (input)=>({
            id: input.value,
            uiType: Types.UIType.CHECKBOX,
            value: input.isSelected
        })
    ;
    return formatOptInsWithSelection(availableOptIns1, selectedOptIns1).map((optin)=>swcHelpers.objectSpread({
            literalText: getLabel(optin.titleKey)
        }, formatOptIn(optin))
    );
};

export { formatOptIns, omitGroupedOptIns, ungroupOptIns };
//# sourceMappingURL=grouped-opt-ins.js.map
